<div class="table-responsive rounded">
    <table class="table rounded">
        <thead *ngIf="field.options?.header">
            <tr [ngClass]="{'d-flex': field.options?.tempSol}">
                <th *ngFor="let item of field.options.header" [ngClass]="item.cssClass || ''" [attr.colspan]="item?.colSpan">
                    {{item.label || ''}}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of field.options.rows" [ngClass]="row?.cssClass">
                <td *ngFor="let col of row.cols" [attr.colspan]="col?.colSpan" [ngClass]="col?.cssClass">
                    <h6 *ngIf="col.options?.label">{{col.options.label}}</h6>
                    <span *ngIf="col.options.path" [ngClass]="col.options?.cssClass">
                        <cv-review-fields
                            class="cv_col"
                            #fields
                            [options]="col.options"></cv-review-fields>
                    </span>
                </td>
            </tr>
        </tbody>
    </table>
</div>